<template>
    <div>
    	<stb-main>
    		<div class="wrapper">
                    <profile-card
                        v-for="(applicant, index) in results"
                        :data-index="index"
                        :key="index"
                        :applicant="applicant"
                    ></profile-card>
    		</div>
    	</stb-main>
    </div>
</template>

<script>
import profileCard from "@/components/general/profileCard"
import _ from 'lodash'

export default {
	components: {
		"profile-card": profileCard
	},
	methods: {
		beforeEnter: function(el) {
            $j(el).addClass("note-in-enter").addClass("note-in-enter-active");
        },
        enter: function (el, done) {
          var delay = el.dataset.index * 150;
          setTimeout(function () {
            $j(el).removeClass("note-in-enter");
            done();
          }, delay)
        },
	},
	data() {
        return {
            query: null,
            results: [],
            /*
            {
            	objectId: "gyIWsMfEY2",
            	name: "Justus Eikhof",
            	email: "justus.eikhof@gmail.de",
            	profileImg: "/static/images/bewerberIcon.svg", // can also be undefined, null or an empty string if no profile picture is given.
            	description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate",
            	address: "August-Bebel-Str. 32c, 18055 Rostock",
            	location: {
            		lat: 54.0901497,
        			lng: 12.1161439
            	}
            },
            {
            	objectId: "gyIWsMfEY2",
            	name: "Justus Eikhof",
            	email: "justus.eikhof@gmail.de",

            	description: "",
            	address: "August-Bebel-Str. 32c, 18055 Rostock",
            },
            {
            	objectId: "gyIWsMfEY2",
            	name: "Justus Eikhof",
            	email: "justus.eikhof@gmail.de",
            	profileImg: "/static/images/bewerberIcon.svg", // can also be undefined, null or an empty string if no profile picture is given.
            	description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate",
            	address: "August-Bebel-Str. 32c, 18055 Rostock",
            	location: {
            		lat: 53.5901497,
        			lng: 11.5161439
            	}
            }
            ],
            */
        };
    },
    watch: {
        query: _.debounce(function(val) {
            this.update_results();
        }, 450),
    },
    mounted() {
        this.$shared.sync(this, 'query');

        this.$api.applicants.load().then((applicants) => {
            this.results = applicants;
        });
    },
    methods: {
        update_results() {
            if (this.query) {
                var query = this.$api.applicants.query();
                //query.fullText('name', this.query);
                query.startsWith('name', this.query);
                this.$api.applicants.load(query).then((results) => {
                    this.results = results;
                });
            } else {
                this.$api.applicants.load().then((results) => {
                    this.results = results;
                });
            }
        },

        beforeEnter: function(el) {
            $j(el)
                .removeClass("note-in-leave")
                .addClass("note-in-enter")
                .addClass("note-in-enter-active");
        },
        enter: function (el, done) {
          var delay = el.dataset.index * 150;
          setTimeout(function () {
            $j(el).removeClass("note-in-enter");
            done();
          }, delay)
        },
        leave: function(el, done) {
            $j(el).addClass("note-in-leave");
            setTimeout(() => {
                done();
            }, 750);
            console.log('Asd')
        },
    },
}
</script>


<style lang="scss" scoped>
	.wrapper {
		display: flex;
		align-items: stretch;
		flex-wrap: wrap;
		padding: 0.75em;
	}

	.wrapper span {
		display: flex;
		align-items: stretch;
		flex-wrap: wrap;
        width: 100%;
	}

	.wrapper .profileCard {
		margin: 0.75em;
	}
</style>


// WEBPACK FOOTER //
// src/pages/applicants.vue